<template>
  <v-dialog
    v-model="dialog"
    dark
    persistent
    content-class="main-dialog"
  >
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-qrcode-scan
      </v-icon> Scan QR Code
    </h2>
    <v-container fluid>
      <h2 class="subtitle-style">
        Scan your site's QR Code for continuing the process
      </h2>
      <div class="pa-4 text-center">
        <div
          id="reader"
          class="scanner-div"
        />
      </div>
      <v-card-actions>
        <v-spacer />
        <v-btn
          class="mt-2"
          color="#37474F"
          @click="close()"
        >
          Cancel
        </v-btn>
        <v-btn
          class="mt-2"
          color="#FF3700"
          @click="confirm()"
        >
          Confirm
        </v-btn>
        <v-spacer />
      </v-card-actions>
    </v-container>
    <centre-spinner
      :loading="loading"
    />
  </v-dialog>
</template>
<script>
import spinner from 'src/views/components/SpinnerCentre';
import { Html5Qrcode } from 'html5-qrcode';
import Constants from 'src/constants';

  export default {
    name: 'QrCodeScanner',
    components: {
      'centre-spinner': spinner,
    },
    data () {
      return {
        dialog: true,
        loading: false,
        html5QrCodeScanner: null,
      };
    },
    watch: {
      dialog: function (newval, oldval) {
        if (newval === false) {
          this.$emit('closed');
        }
      },
    },
    mounted () {
      this.loading = true;
      setTimeout(() => {
        this.scanQrCode();
      }, 2000);
    },
    methods: {
      scanQrCode () {
        this.loading = false;
        this.html5QrCodeScanner = new Html5Qrcode('reader');
        const config = { fps: 10, qrbox: { width: 250, height: 250 } };
        this.html5QrCodeScanner.start({ facingMode: 'environment' }, config, this.qrCodeSuccessCallback);
      },
      qrCodeSuccessCallback (qrCodeUrl) {
        this.loading = true;
        this.html5QrCodeScanner.stop().then(() => {
          this.passScannedUrl(qrCodeUrl);
        }).catch(() => {
          this.loading = false;
          this.dialog = false;
        });
      },
      passScannedUrl (qrCodeUrl) {
        const siteId = qrCodeUrl.split('/').pop();
        this.$store.dispatch('swiftuser/onQrCodeScan', siteId);
        localStorage.setItem('siteId', siteId);
        localStorage.setItem('scannedTime', new Date().getTime());
        setTimeout(() => {
          this.loading = false;
          this.$emit('qr-code-scanned', siteId);
          this.dialog = false;
        }, 2000);
      },
      confirm () {
        this.$store.dispatch('alert/onAlert', {
          message: 'Please scan the QR code before proceeding.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
      },
      close () {
        this.loading = true;
        setTimeout(() => {
          this.html5QrCodeScanner.stop().then(() => {
            this.loading = false;
            this.dialog = false;
          }).catch(() => {
            this.loading = false;
            this.dialog = false;
          });
        }, 2000);
      },
    },
  };
</script>
<style>
.main-dialog {
  background-color: white !important;
}
</style>
<style scoped>
.scanner-div {
  color: #FF3700;
  font-size: 18px;
  font-family: 'Times New Roman', Times, serif;
  font-weight: bold;
}
.title-style {
  color: #37474F;
  margin-left: 20px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.subtitle-style {
  color: #546E7A;
  font-family: 'Times New Roman', Times, serif;
  font-size: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
  text-align: center;
}
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  position: absolute;
  width: 100%;
}
</style>
